{
  "form": {
    "appendOnly": "Den nuvarande versionen tas inte bort. Det du sparar blir en ny version, och båda finns kvar i journalen med vem som skrev dem.",
    "requiredHint": "Fält utan anmärkning måste fyllas i.",
    "optional": "frivilligt",
    "save": "Spara",
    "saving": "Sparar …",
    "cancel": "Avbryt",
    "close": "Stäng",
    "discardQuestion": "Stäng formuläret? Det du har skrivit sparas inte.",
    "discardConfirm": "Stäng utan att spara",
    "discardCancel": "Fortsätt fylla i"
  },
  "notAnswered": "Ej angiven",
  "section": {
    "heading": "Dokumentera och ändra allergier och varningar",
    "allergiesHeading": "Allergiuppgifter i journalen",
    "flagsHeading": "Varningar i journalen",
    "noAllergies": "Inga allergiuppgifter i journalen.",
    "noFlags": "Inga varningar i journalen."
  },
  "allergy": {
    "headingDocument": "Dokumentera allergi",
    "headingCorrect": "Ändra allergiuppgift",
    "openDocument": "Dokumentera allergi",
    "openCorrect": "Ändra allergi",
    "openCorrectNamed": "Ändra allergi: {substance}",
    "explanationDocument": "För en allergi eller överkänslighet som inte finns i journalen. Substansen visas överst på patientens översikt, utan att man behöver bläddra.",
    "explanationCorrect": "För en allergiuppgift som blev fel. Välj Felaktigt införd om uppgiften inte skulle ha dokumenterats alls.",
    "savedDocument": "Allergin är dokumenterad.",
    "savedCorrect": "Ändringen är sparad.",
    "fieldStatus": "Status",
    "fieldSubstance": "Substans",
    "fieldReaction": "Reaktion",
    "fieldSeverity": "Svårighetsgrad",
    "fieldCriticality": "Risk vid ny exponering",
    "fieldVerification": "Bekräftad",
    "hintStatus": "Välj Inga kända allergier när frågan är ställd och svaret är nej. Det är en uppgift i journalen, inte en tom lista.",
    "hintSubstance": "Läkemedel, ämne eller födoämne, med den benämning som används här. Texten översätts aldrig.",
    "hintReaction": "Vad som hände vid exponering.",
    "hintSeverity": "Lämna tom om svårighetsgraden inte är utredd. Tom betyder inte lindrig.",
    "hintCriticality": "Hur farlig en ny exponering bedöms vara. Inte samma sak som hur svår reaktionen var.",
    "hintVerification": "Lämna tom om det inte är utrett.",
    "statusActive": "Aktuell",
    "statusResolved": "Utläkt",
    "statusNoKnownAllergies": "Inga kända allergier",
    "statusEnteredInError": "Felaktigt införd",
    "verificationConfirmed": "Bekräftad",
    "refusal": {
      "statusInvalid": "Statusen känns inte igen. Allergin sparades inte.",
      "statusNotAllowed": "Felaktigt införd kan inte väljas för en ny uppgift — en uppgift som inte ska finnas dokumenteras inte alls. Allergin sparades inte.",
      "substanceMissing": "Substansen måste fyllas i. Allergin sparades inte.",
      "substanceNotAllowed": "Inga kända allergier kan inte kombineras med en substans. Ta bort substansen, eller välj en annan status. Allergin sparades inte.",
      "severityInvalid": "Svårighetsgraden känns inte igen. Allergin sparades inte.",
      "criticalityInvalid": "Risken vid ny exponering känns inte igen. Allergin sparades inte.",
      "verificationInvalid": "Värdet för Bekräftad känns inte igen. Allergin sparades inte.",
      "notFound": "Allergiuppgiften finns inte i journalen. Ändringen sparades inte. Öppna patientöversikten igen.",
      "retracted": "Allergiuppgiften är makulerad i journalen och kan inte ändras. Ändringen sparades inte. Dokumentera en ny uppgift i stället om den behövs.",
      "unknown": "Allergin sparades inte. Försök igen."
    }
  },
  "flag": {
    "headingDocument": "Dokumentera varning",
    "headingCorrect": "Ändra varning",
    "openDocument": "Dokumentera varning",
    "openCorrect": "Ändra varning",
    "openCorrectNamed": "Ändra varning: {type}",
    "explanationDocument": "För isolering, smittrisk, fallrisk, vikt eller att allergistatus inte är utredd. DNR och behandlingsbegränsning kan inte dokumenteras här — de kräver att det står i journalen vem som tog ställning och när.",
    "explanationCorrect": "För en varning som blev fel. Typen kan inte ändras; välj Felaktigt införd om varningen inte skulle ha dokumenterats alls.",
    "savedDocument": "Varningen är dokumenterad.",
    "savedCorrect": "Ändringen är sparad.",
    "correctExisting": "Ändra den som redan finns",
    "fieldType": "Typ av varning",
    "fieldStatus": "Status",
    "fieldValue": "Uppgift",
    "fieldWeight": "Vikt i kilogram",
    "fieldIsolationType": "Typ av isolering",
    "fieldLimitation": "Begränsningen i korthet",
    "fieldNote": "Motivering",
    "hintType": "Typen kan inte ändras efteråt. En varning av fel typ måste makuleras och dokumenteras om.",
    "hintStatus": "Välj Åtgärdad när varningen inte gäller längre, och Felaktigt införd bara när den aldrig skulle ha dokumenterats.",
    "hintWeight": "Skriv vikten med punkt som decimaltecken: 62.4. Komma godtas inte.",
    "hintIsolationType": "Till exempel droppsmitta eller luftsmitta, med den benämning som används här.",
    "hintLimitation": "En rad. Motiveringen skriver du i fältet under.",
    "hintNote": "Bakgrunden till varningen.",
    "statusActive": "Aktuell",
    "statusResolved": "Åtgärdad",
    "statusEnteredInError": "Felaktigt införd",
    "refusal": {
      "typeInvalid": "Typen av varning känns inte igen. Varningen sparades inte.",
      "typeNotDocumentable": "{type} kan inte dokumenteras här: journalen kräver att det står vem som tog ställning och när, och det kan inte anges i den här versionen. Varningen sparades inte.",
      "typeNotDocumentableUnnamed": "Varningstypen kan inte dokumenteras här: journalen kräver att det står vem som tog ställning och när, och det kan inte anges i den här versionen. Varningen sparades inte.",
      "statusInvalid": "Statusen känns inte igen. Varningen sparades inte.",
      "statusNotAllowed": "Felaktigt införd kan inte väljas för en ny varning — en varning som inte ska finnas dokumenteras inte alls. Varningen sparades inte.",
      "valueMissing": "Uppgiften måste fyllas i för den här typen av varning. Varningen sparades inte.",
      "weightMissing": "Vikten måste fyllas i. En vikt utan värde är sämre än ingen vikt: den läses som att frågan är besvarad. Varningen sparades inte.",
      "isolationTypeMissing": "Typen av isolering måste fyllas i. Varningen sparades inte.",
      "weightComma": "Skriv vikten med punkt som decimaltecken: 62.4, inte 62,4. Varningen sparades inte.",
      "weightMalformed": "Vikten läses inte som ett tal. Skriv den med siffror och punkt som decimaltecken: 62.4. Varningen sparades inte.",
      "weightNotPositive": "Vikten måste vara större än noll. Varningen sparades inte.",
      "alreadyDocumented": "Patienten har redan en varning av typen {type}. Ändra den i stället — det är den som visas på översikten. Ingen ny varning sparades.",
      "alreadyDocumentedUnnamed": "Patienten har redan en varning av den typen. Ändra den i stället — det är den som visas på översikten. Ingen ny varning sparades.",
      "notFound": "Varningen finns inte i journalen. Ändringen sparades inte. Öppna patientöversikten igen.",
      "retracted": "Varningen är makulerad i journalen och kan inte ändras. Ändringen sparades inte. Dokumentera en ny varning i stället om den behövs.",
      "unknown": "Varningen sparades inte. Försök igen."
    }
  },
  "refusal": {
    "fieldTooLong": "{field} är för långt. Högst {maximum} tecken. Inget sparades.",
    "versionStale": "Någon annan har sparat en ny version medan formuläret var öppet. Öppna patientöversikten igen och kontrollera vad som står där. Det du skrev sparades inte.",
    "noChange": "Inget är ändrat jämfört med journalen. Ingen ny version skrevs.",
    "supersedesWrong": "Formuläret och journalen är inte överens om vilken version det utgår från. Stäng patientöversikten och öppna den igen. Inget sparades.",
    "patientNotFound": "Patienten finns inte i journalen. Inget sparades.",
    "patientRetracted": "Patienten är makulerad i journalen. Inget sparades.",
    "roleMayNotDocument": "Din roll får inte dokumentera i journalen. Inget sparades.",
    "unavailable": "Ingen kontakt med servern. Inget sparades — låt formuläret vara öppet och försök igen."
  }
}
